import { render } from "./month-calendar.vue?vue&type=template&id=618d9612&bindings={}"
import script from "./month-calendar.vue?vue&type=script&lang=js"
export * from "./month-calendar.vue?vue&type=script&lang=js"

import "./month-calendar.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script